import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation } from 'react-query'

type CreateActivityVariables = {
    data: Record<string, unknown>
}

export const useCreateActivityMutation = () => {
    const { getTokenSilently } = useAuth0()

    const createActivity = async ({ data }: CreateActivityVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.createActivity

        const response = await callAPI(url, method, token, data)

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to create activity')
        }

        return response.id
    }

    return useMutation(createActivity)
}
